<template>
  <div class="s-s-list">
    <div class="title">{{ $t('cscss1') }}</div>
    <ul class="s-item-list">
      <!-- <li class="s-item">
        <div class="s-item-title">网页图标</div>
        <div class="s-item-content flex-b-c">
          <div style="width: 60px;height: 60px;background-color: #000"></div>
          <el-button type="primary" size="mini">应用</el-button>
        </div>
      </li> -->
      <li class="s-item">
        <div class="s-item-title">{{ $t('cscss2') }}</div>
        <div class="s-item-content flex-b-c">
          <el-input v-model="webTitle" :placeholder="$t('cscss2')" size="mini"></el-input>
          <el-button type="primary" size="mini" @click="systemSet('webTitle', webTitle)">{{ $t('cscss8') }}</el-button>
        </div>
      </li>
      <li class="s-item">
        <div class="s-item-title">{{ $t('csh1') }}</div>
        <div class="s-item-content flex-b-c">
          <el-switch v-model="isOpenHelp" @change="(val) => { systemSet('showHelp', val ? '1' : '0') }"
            :active-text="$t('cscss4')" :inactive-text="$t('cscss5')"> </el-switch>
          <!-- <span>显示网页帮助显示</span>
          <div>
            <el-button type="primary" size="mini" @click="systemSet('showHelp','0')">关闭帮助</el-button>
            <el-button type="success" size="mini" @click="systemSet('showHelp','1')">开启帮助</el-button>
          </div> -->
        </div>
        <div class="s-item-content flex-b-c">
          <el-input v-model="helpUrl" size="mini">
            <template slot="prepend">{{ $t('csh1') }}</template>
            <el-button slot="append" @click="systemSet('helpUrl', helpUrl)">{{ $t('csu6') }}</el-button>
          </el-input>
        </div>
      </li>
      <li class="s-item">
        <div class="s-item-title">{{ $t('cscss6') }}</div>
        <div class="s-item-content flex-b-c">
          <el-input v-model="icp" size="mini"></el-input>
          <el-button type="primary" size="mini" @click="systemSet('icp', icp)">{{ $t('cscss8') }}</el-button>
        </div>
      </li>
      <li class="s-item">
        <div class="s-item-title">{{ $t('cscss9') }}</div>
        <div class="s-item-content flex-b-c">
          <div>
            <el-input-number v-model="logExpiration" :min="30" :max="365" :label="$t('cscss10')"
              size="mini"></el-input-number>
            <span style="padding: 0px 8px;">{{ $t('cscss11') }}</span>
          </div>
          <el-button type="primary" size="mini" @click="systemSet('logExpiration', logExpiration)">{{ $t('cscss8')
          }}</el-button>
        </div>
      </li>
      <li class="s-item">
        <div class="s-item-title">{{ $t('spaceManage') }}</div>
        <div class="s-item-content flex-b-c">
          <div>
            <el-input-number v-model="spaceMax" :min="1" :max="999" size="mini"></el-input-number>
            <span style="padding: 0px 8px;">GB</span>
          </div>
          <el-button type="primary" size="mini" @click="systemSet('spaceMax', spaceMax * 1024 * 1024 * 1024)">{{ $t('cscss8')
          }}</el-button>
        </div>
      </li>
      <li class="s-item">
        <div class="s-item-title">{{ $t('cscss12') }}</div>
        <div class="s-item-content flex-d-b-c">
          <div class="s-item-c-b-list">
            <el-checkbox v-for="(item, index) in contentList" v-model="item.isFold" :key="index"
              style="width: 38%;padding:4px;">{{ $t(item.orderName) }}</el-checkbox>
          </div>
          <el-button type="primary" size="mini" @click="setContentBtn">{{ $t('cscss8') }}</el-button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js';

import contentBtnList from '@static/data/contentBtnList.js';

export default {
  name: "SystemSet",
  data() {
    return {
      isOpenHelp: this.$cookies.get('showHelp') == '1' ? true : false,
      webTitle: this.$cookies.get('webTitle'),
      icp: this.$cookies.get('icp'),
      logExpiration: this.$cookies.get('logExpiration'),
      spaceMax: this.$cookies.get('spaceMax') / 1024 / 1024 / 1024 || 2,
      contentList: superClone(contentBtnList),
      helpUrl: this.$cookies.get('helpUrl').replace(/\s/g, "") || 'http://admin.kystarcloud.com/help'
    }
  },
  mounted() {
    const list = this.$cookies.get('controlButton').split(",");
    this.contentList.forEach(item => {
      if (list.indexOf(item.id) !== -1) {
        item.isFold = true;
      }
    });
  },
  methods: {
    systemSet(key, value) {
      value = !value ? " " : value;
      this.$http.post("/admin/access/setSystemLayout", { key, value }, res => {
        // this.$cookies.set(key, value);
        this.$msg({ message: res.tips, type: "success", showClose: true });
        this.$router.go(0);
      });
    },
    setContentBtn() {
      this.systemSet('controlButton', this.contentList.filter((item) => item.isFold).map((item) => item.id).join(","));
    },
  }

}
</script>

<style lang="scss" scoped>
.s-s-list {
  height: calc(100% - 2px);

  // border: 1px dashed var(--theme-color-customized-1);
  .title {
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    text-align: center;
    color: var(--theme-color-customized-1);
    border-bottom: 1px solid #ebeef5;
  }

  .s-item-list {
    height: calc(100% - 60px);
    padding: 0px 16px;
    overflow-y: auto;

    .s-item {
      .s-item-title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-bottom: 1px solid #ebeef5;
        background: #edfbff;
      }

      .s-item-content {
        padding: 16px 16px;
        border-bottom: 1px solid #ebeef5;

        .s-item-c-b-list {
          // height: 160px;
          padding-bottom: 16px;
        }
      }
    }
  }
}
</style>